import { inject, Service } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiClient } from '../../../api/api-client';
import { ApiTypes } from '../../../api/api-types';
import { Api } from '../../../api/generated/api';

type ServerEnvironmentConfig = ApiTypes.TakeawayGoogleAnalyticsResponseDto;

@Service()
export class ServerEnvironmentService {
  private api = inject(ApiClient);

  private serverEnvironment?: ServerEnvironmentConfig;

  getServerEnvironmentConfigObject(): ServerEnvironmentConfig | undefined {
    return this.serverEnvironment;
  }

  getServerEnvironmentConfig$(token: string): Observable<Readonly<ServerEnvironmentConfig>> {
    if (this.serverEnvironment) {
      return of(this.serverEnvironment);
    }

    return this.getConfigFromServer$(token).pipe(
      tap(serverEnvironmentConfig => {
        this.serverEnvironment = serverEnvironmentConfig;
      })
    );
  }

  private getConfigFromServer$(token: string): Observable<ServerEnvironmentConfig> {
    return this.api.get(Api.surveys.takeaway.googleAnalytics, {
      pathParams: { token },
    });
  }
}
